<h2 i18n mat-dialog-title>Save your design</h2>

<mat-dialog-content [formGroup]="saveForm">
    <mat-form-field>
        <input i18n matInput formControlName="saveas">
    </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions>
    <button i18n class="mat-raised-button" (click)="close()">Close</button>
    <button i18n class="mat-raised-button mat-accent" (click)="save()">Save</button>
</mat-dialog-actions>